import type { Headline, ReadHeadline } from '../types';
import HeadlineItem from './HeadlineItem';

interface Props {
  headlines: (Headline | ReadHeadline)[];
  showSource: boolean;
  isRead: boolean;
  emptyMessage: string;
}

export default function HeadlineList({
  headlines,
  showSource,
  isRead,
  emptyMessage,
}: Props) {
  if (headlines.length === 0) {
    return <p className="empty">{emptyMessage}</p>;
  }
  return (
    <ul className={isRead ? 'read-section' : ''}>
      {headlines.map((h) => (
        <HeadlineItem
          key={h.id}
          headline={h}
          showSource={showSource}
          isRead={isRead}
        />
      ))}
    </ul>
  );
}
